export default __webpack_public_path__ + "static/media/FeverLand_01.94bcc0ef.png";